<h2 i18n="A header">Test App</h2>
<select name="animal" aria-label="Select an animal">
  <option value="" i18n="This is a select translation">Cat</option>
  <option value="" i18n>Fish</option>
  <option value="" i18n>Bird</option>
</select>
<div>Date: {{testDate | date: 'fullDate' }}</div>
<div>Time: {{testDate | date: 'fullTime'}}</div>
<br>
<label i18n>Current Currency:</label>

  <select [(ngModel)]="currentCurr"  aria-label="Select a currency">
    <option value="USD" i18n>USD</option>
    <option value="JPY" i18n>Japanese Yen</option>
    <option value="EUR" i18n>Euro</option>
  </select>

  <p i18n>This is a new translation</p>
  <p i18n>next</p>
  <button i18n>next</button>

  <p>Currency: {{currencyVal | currency: currentCurr :"symbol"}}</p>